import React from "react";

function TrainingSchedule() {
  const schedules = [
    {
      training: "Java DSA",
      trainer: "Rahul Sharma",
      date: "24 Aug 2026",
      time: "10:00 AM",
      location: "Noida",
    },
    {
      training: "Python Full Stack",
      trainer: "Amit Kumar",
      date: "28 Aug 2026",
      time: "11:00 AM",
      location: "Delhi",
    },
  ];

  return (
    <div className="page">
      <h1>Training Schedule</h1>
      <p>Upcoming training sessions.</p>

      <div className="schedule-grid">
        {schedules.map((item, index) => (
          <div className="schedule-card" key={index}>
            <div className="date">
              {item.date}
            </div>

            <h2>{item.training}</h2>

            <p>
              Trainer: <b>{item.trainer}</b>
            </p>

            <p>
              Time: <b>{item.time}</b>
            </p>

            <p>
              Location: <b>{item.location}</b>
            </p>
          </div>
        ))}
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .schedule-grid {
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:20px;
          margin-top:25px;
        }

        .schedule-card {
          background:white;
          padding:22px;
          border-radius:12px;
          box-shadow:0 4px 15px rgba(0,0,0,.06);
          border-left:4px solid #2563eb;
        }

        .date {
          color:#2563eb;
          font-size:13px;
          font-weight:bold;
        }

        .schedule-card p {
          color:#64748b;
          font-size:14px;
        }

        @media(max-width:900px) {
          .schedule-grid {
            grid-template-columns:1fr 1fr;
          }
        }

        @media(max-width:600px) {
          .schedule-grid {
            grid-template-columns:1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default TrainingSchedule;